import { render, staticRenderFns } from "./CartRemote.vue?vue&type=template&id=771a4f15&scoped=true&"
import script from "./CartRemote.vue?vue&type=script&lang=js&"
export * from "./CartRemote.vue?vue&type=script&lang=js&"
import style0 from "./CartRemote.vue?vue&type=style&index=0&id=771a4f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771a4f15",
  null
  
)

component.options.__file = "CartRemote.vue"
export default component.exports